export default __webpack_public_path__ + "static/media/M.26d312bb.png";